import { useMemo } from 'react';

import { platformDownloads, type PlatformDownload } from '@/config/downloads';
import { useLocale } from '@/i18n/locale-context';

export function useLocalizedDownloads(): PlatformDownload[] {
  const { t } = useLocale();

  return useMemo(
    () =>
      platformDownloads.map((item) => ({
        ...item,
        label: t.platforms[item.id].label,
        hint: t.platforms[item.id].hint,
      })),
    [t]
  );
}
